// Placeholder for GitLab FOSS
// Actual implementation: ee/app/assets/javascripts/ai/editor_actions/generate_description.js
export const generateDescriptionAction = () => {};
